import { useStore } from "vuex";
import { ref, computed, watch } from 'vue';
import {
  useDocumentSpacesCountQuery,
} from "@/graphql/operations";

export function useSpaceModalDisplay() {
  const store = useStore();

  const displayCreateDocumentSpaceModal = ref(false);
  const displayCopyDocumentSpaceModal = ref(false);
  const displayUpgradeModal = ref(false);
  const canUseSharedSpaces = computed(() =>
    store.getters.user.canUseSharedSpaces(),
  );
  const createDocumentSpaceModalVisible = computed(
    () => canUseSharedSpaces.value && displayCreateDocumentSpaceModal.value,
  );
  const copyDocumentSpaceModalVisible = computed(
    () => canUseSharedSpaces.value && displayCopyDocumentSpaceModal.value,
  );
  const upgradeModalVisible = computed(
    () => canUseSharedSpaces.value && displayUpgradeModal.value,
  );

  const { data, fetching, executeQuery } = useDocumentSpacesCountQuery({
    requestPolicy: "network-only",
    pause: computed(() => !canUseSharedSpaces.value),
  });
  const numSpaces = computed(() => data.value?.documentSpaces?.totalCount);
  const reachedMaxSpaces = computed(
    () =>
      numSpaces.value &&
      numSpaces.value >= 3 &&
      !store.getters.user.hasDocumentSpaces()
  );

  const handleModalDisplay = async (modalType: string) => {
    if (!canUseSharedSpaces.value) return;
    await executeQuery();
    if (reachedMaxSpaces.value) {
      displayUpgradeModal.value = true;
    } else {
      if (modalType === 'create') {
        displayCreateDocumentSpaceModal.value = true;
      } else if (modalType === 'copy') {
        displayCopyDocumentSpaceModal.value = true;
      }
    }
  };

  watch(canUseSharedSpaces, (enabled) => {
    if (enabled) return;
    displayCreateDocumentSpaceModal.value = false;
    displayCopyDocumentSpaceModal.value = false;
    displayUpgradeModal.value = false;
  });

  return {
    displayCreateDocumentSpaceModal,
    displayCopyDocumentSpaceModal,
    displayUpgradeModal,
    createDocumentSpaceModalVisible,
    copyDocumentSpaceModalVisible,
    upgradeModalVisible,
    handleModalDisplay,
  };
}
